import React, { ComponentProps } from 'react';
import { Box, Grid } from '@material-ui/core';

import { BackArrowButton } from '../Buttons';

interface TitleHeaderProps {
  children: ComponentProps<any>['children']
  breadcrumb?: ComponentProps<any>['children']
  backButton?: boolean
}

export const TitleHeader = (props: TitleHeaderProps) => {
  const {
    children,
    breadcrumb,
    backButton = true
  } = props;

  return (
    <Box>
      <Box ml={backButton ? -2 : 0}>
        <Grid container alignItems="center">
          {backButton && (
            <Grid item>
              <Box pr={0.5}><BackArrowButton /></Box>
            </Grid>
          )}
          <Grid item>{children}</Grid>
        </Grid>
      </Box>
      {!!breadcrumb && (
        <Box>{breadcrumb}</Box>
      )}
    </Box>
  );
};

export default TitleHeader;
